<template>
  <div class="soluction">
    
    <div class="banner_pc" @click="getHouse">
      <img src="https://www.bjecpower.com/img/gw/pb03.jpg" alt="">
    </div>
    <div class="banner_mo">
      <img src="https://www.bjecpower.com/img/gw/mb03.png" alt="">
    </div>
    <!-- 行业痛点 -->
    <div class="solu_header">
      <div class="home_con">
        <div class="title_flex">
          <p class="solu_title">行业痛点</p>
          <p class="solu_title_er">能源成本极难以控制，扩建规模太过困难</p>
        </div>
        <div class="header_leftzong">
          <div class="header_left">
            <!-- 背景图 -->
            <div class="bg_title aa">
              <img class="bg_none" src="@/assets/mobile/6.png" alt="" />
              <span>能源使用成本过高</span>
            </div>
            <p>
              电源使用高峰期相比低谷期，成本差近3
              倍，但在低谷期需求确远低于高峰期，能源成本居高不下。间接性促成充电盈利难，运营难的行业难题。
            </p>
          </div>
          <div class="header_left left_aa">
            <!-- 背景图 -->
            <div class="bg_title bb">
              <img class="bg_none" src="@/assets/mobile/7.png" alt="" />
              <span>能源扩建成本过高</span>
            </div>

            <p>
              场站因受限于额定功率限制，无法扩充过多的充电桩，且过多的充电桩会增加充电高峰期限功率的时间。很大程度的提升了扩建的成本。
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 智慧能源解决方案 -->
    <div class="home_con">
      <div class="title_flex">
        <p class="solu_title solu_zhi">智慧能源解决方案</p>
        <p class="solu_title_er">全方位落地解决方案,适应多种类型场景下使用</p>
      </div>
      <div class="hh_title chuneng">
        <img src="@/assets/solu/hh.png" alt="" />
        <p>充电储能系统</p>
      </div>
      <div class="imgs">
        <img src="@/assets/solu/3.png" alt="" />
        <img src="@/assets/solu/4.png" alt="" />
      </div>
      <div class="energy_con chongdian">
        <div>
          <img src="@/assets/solu/5.png" alt="" />
          <p>
            项目中630kVA箱变，一般设计最多为6台90kw充电机提供电源，在Dynamic系统的支持下，
            增加了6台90kW充电机，实现为12台90kW充电桩提供电源，同时确保用电安全。
          </p>
        </div>
        <div>
          <img class="img_ri" src="@/assets/solu/6.png" alt="" />
          <p>
            通过配置充电站Boost储能系统，实现在充电负荷高峰提供额外的电源功率支持。
          </p>
        </div>
      </div>

      <!-- 智慧能源调度 -->

      <div class="hh_title">
        <img src="@/assets/solu/hh.png" alt="" />
        <p>智慧能源调度</p>
      </div>
      <img class="zhihui_img" src="@/assets/solu/7.png" alt="" />
      <div class="energy_con">
        <div>
          <img src="@/assets/solu/8.png" alt="" />
          <p>
            在国标的框架下，采用轻量级的技术方案，在充电桩内部增加Dynamic模块，可适配所有充电设备，不影响原有的充电控制系统。
          </p>
        </div>
        <div>
          <img src="@/assets/solu/9.png" alt="" />
          <p>
            Dynamic实现桩与桩在电源侧不再孤立，通过自组网实现能量管理和用电安全
          </p>
        </div>
        <div class="pad_txt">
          <img src="@/assets/solu/10.png" alt="" />
          <p>通过负荷分析，实现最优化的能量管理策略。</p>
        </div>
      </div>

      <!-- 能量管理平台 -->
      <div class="neng_pc" ref="neng_pc">
        <div class="hh_title">
          <img src="@/assets/solu/hh.png" alt="" />
          <p>能量管理平台</p>
        </div>
        <img class="neng_img" src="@/assets/solu/11.png" alt="" />
        <ul class="newenergy" ref="newenergy">
          <li v-for="(item, index) in newList" :key="index">
            <img :src="item.img" alt="" />
            <div>
              <p class="li_aa">{{ item.name }}</p>
              <p class="li_bb">{{ item.tit }}</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="neng_mo">
        <div class="hh_title">
          <img src="@/assets/solu/hh.png" alt="" />
          <p>能量管理平台</p>
        </div>

        <div class="home_con" id="show_content">
           <ul class="pages">
            <li v-for="(item, index) in initSize() ? 2 : 4"  :key="index">
              <p v-show="activeIndex == index" ref="page_size"></p>
            </li>
          </ul>
          <div class="swiper_mobg">
            <div class="swiper_pc">
              <div class="swiper-container swiper-no-swiping">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <ul>
                      <li><img src="@/assets/mobile/s1.png" alt="" /></li>
                    </ul>
                  </div>
                  <div class="swiper-slide">
                    <ul>
                      <li><img src="@/assets/mobile/s2.png" alt="" /></li>
                    </ul>
                  </div>
                  <div class="swiper-slide">
                    <ul>
                      <li><img src="@/assets/mobile/s3.png" alt="" /></li>
                    </ul>
                  </div>
                  <div class="swiper-slide">
                    <ul>
                      <li><img src="@/assets/mobile/s4.png" alt="" /></li>
                    </ul>
                  </div>
                  <div class="swiper-slide">
                    <ul>
                      <li><img src="@/assets/mobile/s5.png" alt="" /></li>
                    </ul>
                  </div>
                  <div class="swiper-slide">
                    <ul>
                      <li><img src="@/assets/mobile/s6.png" alt="" /></li>
                    </ul>
                  </div>
                </div>
               
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>

        <ul class="newenergy_mo">
          <li v-for="(item, index) in newList" :key="index">
            <div>
              <img :src="item.img" alt="" />
              <span>{{ item.name }}</span>
            </div>
            <p>{{ item.tit }}</p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="solu_header jing">
      <div class="home_con">
        <div class="title_flex">
          <p class="solu_title">应用场景</p>
          <p class="solu_title_er">全方位落地方案,可应用于多种场景类型</p>
        </div>

        <!-- 背景图片 -->
        <ul class="appli">
          <li ref="keyframes_1" @mouseover="appliMouseover(0)">
            <div class="app_hover" style="display: block">
              <img src="@/assets/solu/a1.png" alt="" />
              <p class="appnor_tit">酒店</p>
              <p class="appnor_line"></p>
              <p class="appnor_con">提升酒店谷电利用率，较少电力成本支出，保障酒店不受外部电源影响，提升酒店生产力。</p>
            </div>
            <div class="app_nor" style="display: none">
              <img src="@/assets/solu/a1.png" alt="" />
              <p class="appnor_tit">酒店</p>
            </div>
            <img class="maxImage" :src="imagesList[0].max" alt="" style="opacity:1">
          </li>
          <li
            style="margin-left: 23px"
            ref="keyframes_2"
            @mouseover="appliMouseover(1)"
          >
            <div class="app_hover">
              <img src="@/assets/solu/b1.png" alt="" />
              <p class="appnor_tit">物流园区</p>
              <p class="appnor_line"></p>
              <p class="appnor_con">
                压缩专用站能源成本，短期可不受外部电源影响，为物流/公交/出租车等集团式充电客户提供出行保障，实现商业价值最大化。
              </p>
            </div>
            <div class="app_nor">
              <img src="@/assets/solu/b1.png" alt="" />
              <p class="appnor_tit">物流园区</p>
            </div>
            <img class="maxImage" :src="imagesList[1].max" alt="">
          </li>
          <li
            style="margin-left: 23px"
            ref="keyframes_3"
            @mouseover="appliMouseover(2)"
          >
            <div class="app_hover">
              <img src="@/assets/solu/c1.png" alt="" />
              <p class="appnor_tit">社会场站</p>
              <p class="appnor_line"></p>
              <p class="appnor_con">
                从电源端"削峰填谷"实现盈利。打破传统电力负荷限制，为充电客户持续输出最大需求功率，提升用户充电体验及运营商服务效率。
              </p>
            </div>
            <div class="app_nor">
              <img src="@/assets/solu/c1.png" alt="" />
              <p class="appnor_tit">社会场站</p>
            </div>
            <img class="maxImage" :src="imagesList[2].max" alt="">
          </li>
          <li
            style="margin-left: 23px"
            ref="keyframes_4"
            @mouseover="appliMouseover(3)"
          >
            <div class="app_hover">
              <img src="@/assets/solu/d1.png" alt="" />
              <p class="appnor_tit">工厂储能</p>
              <p class="appnor_line"></p>
              <p class="appnor_con">
                在谷电期进行电源储能，等峰电期释放电能，极大的减少了对工厂设备的电力成本支出。
              </p>
            </div>
            <div class="app_nor">
              <img src="@/assets/solu/d1.png" alt="" />
              <p class="appnor_tit">工厂储能</p>
            </div>
            <img class="maxImage" :src="imagesList[3].max" alt="">
          </li>
        </ul>

        <!-- 移动背景图片 -->
        <ul class="appli_mo">
          <li>
            <div>
              <img src="@/assets/solu/a1.png" alt="" />
              <span>酒店</span>
            </div>
            <p>
              提升酒店谷电利用率，较少电力成本支出，保障酒店不受外部电源影响，提升酒店生产力。
            </p>
          </li>
          <li>
            <div>
              <img src="@/assets/solu/b1.png" alt="" />
              <span>物流园区</span>
            </div>
            <p>
              压缩专用站能源成本，短期可不受外部电源影响，为物流/公交/出租车等集团式充电客户提供出行保障，实现商业价值最大化。
            </p>
          </li>
          <li>
            <div>
              <img src="@/assets/solu/c1.png" alt="" />
              <span>社会场站</span>
            </div>
            <p>
              从电源端"削峰填谷"实现盈利。打破传统电力负荷限制，为充电客户持续输出最大需求功率，提升用户充电体验及运营商服务效率。
            </p>
          </li>
          <li>
            <div>
              <img src="@/assets/solu/d1.png" alt="" />
              <span>工厂储能</span>
            </div>
            <p>
              在谷电期进行电源储能，等峰电期释放电能，极大的减少了对工厂设备的电力成本支出。
            </p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 回到顶部 -->
    <div class="home_pos" v-if="top">
      <div class="father">
          <ul class="son">
            <li>
              <img src="@/assets/solu/111.png" alt="" />
              <div>
                <p>咨询人</p>
                <p>刘经理</p>
              </div>
            </li>
            <li>
              <img src="@/assets/solu/222.png" alt="" />
              <div>
                <p>岗位</p>
                <p>市场经理</p>
              </div>
            </li>
            <li>
              <img src="@/assets/solu/333.png" alt="" />
              <div>
                <p>电话</p>
                <p>17710505631</p>
              </div>
            </li>
            <li>
              <img src="@/assets/solu/44.png" alt="" />
              <div>
                <p>邮箱</p>
                <p>hrzl@ec-power.cn</p>
              </div>
            </li>
            <li>
              <img src="@/assets/solu/55.png" alt="" />
              <div>
                <p>微信</p>
                <p>hezlf_ecpower</p>
              </div>
            </li>
          </ul>
      </div>

      <div class="father_we">
        <div class="son_we">
          <img src="@/assets/pc/er.png" alt="" />
        </div>
        
      </div>

      <div @mouseover="gohover" v-if="!goFlag">
        <img src="@/assets/pc/goa.png" class="goimg" alt="" />
      </div>
      <div @click="backtop" @mouseout="goOut" v-else>
        <img src="@/assets/pc/gob.png" class="goimg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex:0,
      goFlag: false,
      top: false,
      newList: [
        {
          img: "https://www.bjecpower.com/img/gw/12.png",
          name: "运行统计",
          tit: "对充电桩运行的状态及时统计。",
        },
        {
          img: "https://www.bjecpower.com/img/gw/13.png",
          name: "谷电利用",
          tit: "谷时存储电能峰时使用情况。",
        },
        {
          img: "https://www.bjecpower.com/img/gw/14.png",
          name: "充电桩实时监控",
          tit: "充电桩实时情况监控，为运营人员提供便利。",
        },
        {
          img: "https://www.bjecpower.com/img/gw/15.png",
          name: "电池系统环境管理",
          tit: "电池状态的实时反馈，对设备的状态及时掌握。",
        },
        {
          img: "https://www.bjecpower.com/img/gw/16.png",
          name: "充放电控制策略",
          tit: "监控充放电时间，对充放电具体情况进行统计。",
        },
        {
          img: "https://www.bjecpower.com/img/gw/17.png",
          name: "充电负荷跟踪",
          tit: "站点一周内点位的功率、负载功率、储能功率变化情况。",
        },
      ],
      keyframesIndex: 0,
      imagesList: [
        {
          min: "https://www.bjecpower.com/img/gw/a.png",
          max: "https://www.bjecpower.com/img/gw/aa.png",
        },
        {
          min: "https://www.bjecpower.com/img/gw/b.png",
          max: "https://www.bjecpower.com/img/gw/bb.png",
        },
        {
          min: "https://www.bjecpower.com/img/gw/c.png",
          max: "https://www.bjecpower.com/img/gw/pb07.png",
        },
        {
          min: "https://www.bjecpower.com/img/gw/d.png",
          max: "https://www.bjecpower.com/img/gw/dd.png",
        },
      ],
      offsetTops:{
        list:[]
      }
    };
  },

  mounted() {
    
    let parentArr = ['neng_pc']
    let arr = ['newenergy']
    arr.map((item,index)=>{
      this.$set(this.offsetTops, item+'OffsetTop', this.$refs[parentArr[index]].offsetTop - this.$refs[item].offsetTop )
      this.offsetTops.list.push(this.$refs[item])
    })
    
    var THIS = this;
    window.addEventListener("scroll", function () {
      //监听滚动
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= 500) {
        //如果当前滚动位置大于您的所需要达到的高度则显示置顶元素，反之不显示
        THIS.top = true;
      } else {
        THIS.top = false;
      }
      THIS.scrollChange(scrollTop)
    });

    let _this = this;
    let mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal", // 垂直切换选项
      loop: true, // 循环模式选项
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        // disableOnInteraction: false,
      },
      autoplay: true,
      delay: 5000,
      autoplayDisableOnInteraction: false,
      pagination: {
        el: ".swiper-pagination",
      },
    });
  },
  methods: {
     initSize() {
      return document.body.clientWidth > 768;
    },
    scrollChange(e){

      // console.log(2704-615,'---------',e)
      this.$nextTick(()=>{
        let arr = ['newenergy']
        this.offsetTops.list.map((item,index)=>{
          // console.log(Number(this.offsetTops[arr[index]+'OffsetTop']))
          if(Number(this.offsetTops[arr[index]+'OffsetTop']) < e){

            item.style.display = 'block'
            item.style.display = 'flex'
          }else{
            item.style.display = 'none'
          }
        })
      })
      
    },
    appliMouseover(e) {
      // let keyframes = this.$refs.keyframes
      // console.log(keyframes)
      if (e === this.keyframesIndex) {
        return;
      }
      let _this = this;
      for (let i = 0; i < 4; i++) {
        let keyframesStyle = _this.$refs["keyframes_" + (i + 1)].children;
        if (e === i) {
          _this.$refs["keyframes_" + (i + 1)].style.width = "41.3%";
          document.getElementsByClassName('maxImage')[i].style.opacity = 1
          
          // _this.$refs[
          //   "keyframes_" + (i + 1)
          // ].style.backgroundImage = `url(${_this.imagesList[i].max})`;
          keyframesStyle[0].style.display = "block";
          keyframesStyle[1].style.display = "none";
          keyframesStyle[0].style.maxHeight = "106.5px";
          setTimeout(() => {
            keyframesStyle[0].style.bottom = "24px";
            keyframesStyle[0].style.maxHeight = "204px";
          }, 400);
        } else {
          _this.$refs["keyframes_" + (i + 1)].style.width = "17.2%";
          document.getElementsByClassName('maxImage')[i].style.opacity = 0
          // _this.$refs[
          //   "keyframes_" + (i + 1)
          // ].style.backgroundImage = `url(${_this.imagesList[i].min})`;
          keyframesStyle[0].style.bottom = "0px";
          keyframesStyle[0].style.maxHeight = "106.5px";
          // keyframesStyle[0].style.maxHeight = '204px'
          setTimeout(() => {
            keyframesStyle[0].style.display = "none";
            keyframesStyle[1].style.display = "block";
            // keyframesStyle[0].style.maxHeight = '0px'
          }, 1100);
        }
      }
      this.keyframesIndex = e;
    },
    getHouse() {
      this.$bus.$emit("click");
    },
    gohover() {
      this.goFlag = true;
    },
    goOut() {
      this.goFlag = false;
    },
    gohover() {
      this.goFlag = true;
    },

    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>



<style>
#show_content
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  width: 30px;
  height: 3px;
  background: #0084ff;
  border-radius: 0;
}

#show_content .swiper-pagination-bullet-active {
  background: #e7ecf3;
  width: 30px !important;
}
#show_content .swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 22px;
}
@media screen and (max-width: 768px) {
   #show_content .swiper-container {
    margin: 0px 15px!important;;
  }
  #show_content
    .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    width: 14px;
    height: 3px;
    background: #0084ff!important;
    border-radius: 0;
  }

  #show_content .swiper-pagination-bullet-active {
    background: #fff!important;
    width: 14px !important;
  }
  #show_content .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    /* bottom: 46px; */
    bottom: 13px;
    left:-22px;
  }
}
</style>

<style scoped>

 .pages{display:none;}
/* @keyframes son {
  0% {
    opacity: 0;
    max-width: 0px;
  }
  100% {
    opacity: 1;
    max-width: 233px;
  }
} */
.neng_pc{
  position: relative;
  margin-bottom: 462.96px;
}
.newenergy{
  position: absolute;
  left: 0;
  top: 594.72px;
  animation: newenergy 1s linear; 
}
@keyframes newenergy{
  0% {
    top: 614.72px;
  }
  100% {
    top: 594.72px; 
  }
}
.son li {
  display: flex;
}
.son li img {
  width: 20px;
  height: 20px;
  margin: 24px 0px 0px 32px;
}
.son li div {
  margin-left: 12px;
  margin-top: 18px;
  text-align: left;
}
.son li div p:nth-child(1) {
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5a6073;
  line-height: 21px;
}
.son li div p:nth-child(2) {
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 18px;
  margin-top: 3px;
}
/* 交集选择器，所以父子关系的div盒子才可以 */
/* .father:hover .son .father_ul {
  transition: width 800ms;
  width: 233px;
  height:318px;
  overflow: hidden;
} */
.neng_mo,
.appli_mo {
  display: none;
}
.jing {
  height: 510px;
}
.neng_img {
  width: 100%;
  height: 458px;
}
.pad_txt {
  padding: 72px 0px;
}
.zhihui_img {
  width: 100%;
  height: 463px;
}
.img_ri {
  margin-left: 16px;
}
.bg_none {
  display: none;
}

.banner_pc{
  width:100%;
  box-sizing: border-box;
}
.banner_pc img{
  max-width:100%;
  width:100%;
}

.banner_mo {
  display: none;
}
.home_pos {
  position: fixed;
  right: 16px;
  bottom: 6%;
  width: 100px;
}

.home_pos .goimg {
  width: 115px;
  height: 115px;
  cursor: pointer;
}

.father {
  width: 99px;
  height: 112px;
  background-image: url("https://www.bjecpower.com/img/gw/zx.png");
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
}

.son {
  height: 0px;
  width: 0px;
  /* max-width: 0px; */
  position: absolute;
  top: 0;
  right: 95%;
  /* 收回的时候快一点 */
  transition: width 200ms;
  overflow: hidden;
}
.father:hover .son {
  /* 将transition写在;hover中，很是巧妙 */
  /* 伸展的时候慢一点 */
  width: 233px;
  /* max-width: 233px; */
  height: 318px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(0, 52, 144, 0.12);
  transition: width 800ms;
  /* animation: son 0.5s linear; */
}
.father_we {
  width: 99px;
  height: 112px;
  background-image: url("https://www.bjecpower.com/img/gw/wx.png");
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
}

.son_we {
  height: 214px;
  width: 190px;
  /* max-width: 0px; */
  position: absolute;
  top: 0;
  right: 95%;
  /* 收回的时候快一点 */
  /* transition: width 200ms; */
  overflow: hidden;
}
.son_we img{
  height: 214; 
  width: 190px;
  position: absolute;
  top: 0;
  right: -100%;
}
/* 交集选择器，所以父子关系的div盒子才可以 */
.father_we:hover .son_we img {
  /* 将transition写在;hover中，很是巧妙 */
  /* 伸展的时候慢一点 */
  width: 190px;
  height: 214px;
  transition: 800ms;
  right:0;
}

.soluction {
  width: 100%;
  background: #fff;
}

.solu_header {
  width: 100%;
  /* height: 418px; */
  background: #f3f5fc;
}
.title_flex {
  display: flex;
  padding: 56px 0px 28px 0px;
}
.solu_title {
  font-size: 32px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #191c27;
  line-height: 48px;
}
.solu_title_er {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9ea5bb;
  line-height: 63px;
  margin-left: 16px;
}
.header_left {
  width: 48.8%;
  height: 226px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
}
.bg_title {
  width: 100%;
  height: 86px;

  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.aa {
  background-image: url("https://www.bjecpower.com/img/gw/1.png");
}
.bb {
  background-image: url("https://www.bjecpower.com/img/gw/2.png");
}
.bg_title span {
  display: block;
  font-size: 22px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 86px;
  text-align: left;
  padding-left: 24px;
}
.header_left p {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 21px;
  text-align: left;
  padding: 32px 24px;
}
.hh_title {
  text-align: left;
}
.hh_title img {
  width: 28px;
  height: 28px;
}
.hh_title p {
  font-size: 24px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #191c27;
  line-height: 36px;
  margin: 21px 0px 48px 0px;
}
.imgs {
  display: flex;
  width:100%;
}
.imgs img {
  width: 47.7%;
  height: 357px;
}
.imgs img:nth-child(2) {
  margin-left: 47px;
}
.energy_con {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 43px 0px 0px 0px;
  text-align: left;
}
.chongdian{ padding-bottom:72px!important;}
.energy_con div {
  display: flex;
  width:50%;
  align-items: center;
}
.energy_con div:nth-child(2){
   justify-content: end;
}
.energy_con div img {
  width: 70px;
  height: 75px;
  vertical-align: middle;
}
.energy_con div p {
  display: inline-block;
  width: 340px;
  margin-left: 32px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 21px;
}
.newenergy {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  text-align: left;
  padding-bottom: 59px;
}
.newenergy li {
  width: 44%;
  display: flex;
  margin-top: 72px;
}
.newenergy li:nth-child(1),
.newenergy li:nth-child(2) {
  margin-top: 48px;
}
.newenergy li img {
  width: 70px;
  height: 75px;
}
.newenergy div {
  margin-left: 32px;
}
.newenergy .li_aa {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 30px;
}
.newenergy .li_bb {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 21px;
  margin-top: 16px;
}
.appli {
  display: flex;
  text-align: left;
  position: relative;
}
.appli li img {
  width: 43px;
  height: 40px;
}
.appli li:hover .maxImage{
  opacity:1;
  transition: 0.8s;
}
.appli li .maxImage{
  width: 100%;
  height: 100%;
  position: absolute;
  /* display: none; */
  opacity: 0;
  z-index: 1;
}
.appli li {
  /* width: 172px; */
  width: 17.2%;
  height: 310px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  position: relative;
  cursor: pointer;
  bottom: 0;
  transition: 0.8s;
}
.appli li:first-child {
  width: 41.3%;
}
.appli li:nth-child(1) {
  background-image: url("https://www.bjecpower.com/img/gw/a.png");
}
.appli li:nth-child(2) {
  background-image: url("https://www.bjecpower.com/img/gw/b.png");
}
.appli li:nth-child(3) {
  background-image: url("https://www.bjecpower.com/img/gw/pb06.png");
}
.appli li:nth-child(4) {
  background-image: url("https://www.bjecpower.com/img/gw/b03.png");
}

.app_hover {
  /* width: 378px; */
  width: 90%;
  max-height: 204px;
  height: auto;
  position: absolute;
  left: 24px;
  bottom: 24px;
  transition: 1s;
  display: none;
  overflow: hidden;
  z-index: 2;
}
/* .appli li .app_hover:first-child{
  display: block;
} */
.appnor_line {
  border: 1px solid #ffffff;
  margin: 24px 0px 15px 0px;
  opacity: 0.6;
}
.appnor_con {
  width: 345px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  line-height: 27px;
}
.app_nor {
  position: absolute;
  left: 24px;
  bottom: 24px;
  transition: 1s;
  display: block;
}
/* .appli li .app_nor:first-child{
  display: none;
} */

.appnor_tit {
  font-size: 26px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 39px;
}
</style>


<style scoped>
@media screen and (max-width: 768px) {
  .chongdian{ padding-bottom:0px!important;}
  .chuneng{
  margin-top:22px!important;
}
  .home_con {
  position: relative;
}
  .pages {
    display: block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 25px;
  height: 3px;
  display: flex;
  box-sizing: border-box;
  padding: 0 0 0 8px;
}
.pages li {
  position: relative;
  width: 15px;
  margin-right: 8px;
  height: 3px;
  background: #e7ecf3;
}
.pages li p {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0084ff;
  /* z-index: -1; */
  animation: slidetounlock 5s linear;
}
@keyframes slidetounlock {
  0% {
    width: 0px;
  }
  100% {
    width: 100%;
  }
}
  .solu_title_er {
    font-size: 12px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #9ea5bb;
    line-height: 11px;
    margin-left:0px;
  }
  .solu_zhi{
    margin-top:20px;
  }
  .banner_pc {
    display: none;
  }
  .banner_mo{
    display:block;
  width:100%;
  box-sizing: border-box;
}

.banner_mo img{
  max-width:100%;
  width:100%;
}
  
  .swiper_pc .swiper-slide ul {
    margin-top: 40px;
  }
  .swiper_pc .swiper-slide ul li {
    width:100%!important;
    height: 239px;
    /* margin: 0px 15px; */
  }
  .swiper_pc .swiper-slide ul li img {
    width: 100%;
    height: 100%;
  }
  .neng_pc,
  .appli {
    display: none;
  }
  .jing {
    height: auto;
    margin-bottom: 40px;
  }
  .neng_mo {
    display: block;
  }
  .appli_mo {
    display: block;
  }
  .appli_mo div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 31px;
  }
  .appli_mo div img {
    width: 23px;
    height: 20px;
  }
  .appli_mo div span {
    display: block;
    font-size: 20px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 20px;
    margin-left:8px;
  }
  .appli_mo p {
    width: 76%;
    font-size: 13px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #ffffff;
    line-height: 19px;
    text-align: left;
    margin: 31px auto 0px auto;
  }
  
  .appli_mo li {
    width: 92%;
    height: 173px;
    margin: 15px 15px 0px 15px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .appli_mo li:nth-child(1) {
    background-image: url("https://www.bjecpower.com/img/gw/htl.png");
  }
  .appli_mo li:nth-child(2) {
    background-image: url("https://www.bjecpower.com/img/gw/tp1.png")!important;
  }
  .appli_mo li:nth-child(3) {
    background-image: url("https://www.bjecpower.com/img/gw/mb07.png")!important;
  }
  .appli_mo li:nth-child(4) {
    background-image: url("https://www.bjecpower.com/img/gw/fbp.png")!important;
  }
  .newenergy_mo {
    display: block;
    margin: 0px 15px;
  }
 
  .newenergy_mo li:nth-child(1){
    margin-top:32px;
  }
  .newenergy_mo li{
    margin: 32px 0px 15px 0px;
  }
   .newenergy_mo li div {
    display: flex;
    align-items: center;
    /* margin: 32px 0px 15px 0px; */
  }
  .newenergy_mo li div img {
    width: 35px;
    height: 35px;
    margin-right: 12px;
  }
  .newenergy_mo li div span {
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
    line-height: 18px;
  }
  .newenergy_mo li p {
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #5a6073;
    line-height: 21px;
    text-align: left;
  }

  .zhihui_img {
    width: 92%;
    height: 160px;
    margin-top: 32px;
  }
  .pad_txt {
    padding: 15px 0px 0px 0px;
  }
  .imgs {
    display: block;
    margin-top: 32px;
  }
  .img_ri {
    margin-left: 0px!important;
  }
  .energy_con {
    display: block;
    flex-wrap: wrap;
    width: 100%;
    padding: 0px;
    /* padding: 8px 15px 0px 15px; */
    text-align: left;
  }
  .energy_con div {
    display: flex;
    width: 91%;
    align-items: center;
    margin: 32px 15px 0px auto;
  }
  .energy_con div img {
    width: 35px;
    height: 35px;
    vertical-align: middle;
  }
  .energy_con div p {
    display: inline-block;
    /* width: 294px; */
    margin-left: 16px;
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #5a6073;
    line-height: 21px;
  }
  .hh_title {
    text-align: left;
    display: flex;
    align-items: center;
    margin-top: 49px;
  }
  .hh_title img {
    width: 16px;
    height: 17px;
    margin: 0px 12px 0px 15px;
  }
  .hh_title p {
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
    line-height: 18px;
    margin: 0px;
  }
  .imgs img {
    width: 92%;
    height: 258px;
  }
  .imgs img:nth-child(2) {
    margin-left: 0px;
    margin-top: 16px;
  }
  .bg_none {
    display: block;
  }
  .solu_header {
    width: 100%;
    /* height: 418px; */
    background: #fff;
  }
  .header_left p {
    padding: 17px 15px;
    text-align: left;
  }
  .title_flex {
    display: block;
    /* padding: 50px 0px 9px 0px; */
  }
  .solu_title {
    font-size: 22px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #191c27;
    line-height: 22px;
  }
  .solu_title_er {
    font-size: 12px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #9ea5bb;
    line-height: 11px;
    margin-top: 16px;
  }
  .header_leftzong {
    display: block;
    /* height:500px; */
    padding-top: 10px;
  }
  .first {
    display: none;
  }
  .header_left {
    width: 100%;
    height: 136px;
    border: none;
  }
  .bg_title {
    width: 100%;
    display: flex;
    align-items: center;
    height: 0px;
    margin: 32px 0px 17px 0px;
  }
  .bg_title img {
    display: block;
    width: 35px;
    height: 35px;
    margin-left: 12px;
  }
  .bg_title span {
    display: block;
    margin-left: -12px;
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27 !important;
    line-height: 16px;
    text-align: left;
  }
  .aa {
    background-image: none !important;
  }
  .bb {
    background-image: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/solu/solua.vue